import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';


const IssuesReportTable = ({jobsData}) => {
  const history = useNavigate();
  console.log(jobsData)
  const [currentUser, setCurrentUser]= useState({})
      const handleDelete = async(id)=>{
    
            const user = JSON.parse(localStorage.getItem('user'));
            let headersList = {
                "Accept": "*/*",
                "Content-Type": "application/json"
               }
        
               let response = await fetch(`${API_URL}/api/maintenance/delete/single-issues/${id}`, { 
                 method: "POST",
                 headers: headersList
               });
               if(response.status === 200){
                window.location.href='/issue-reported';
               }else{
                 alert('Server Problem')
               }
      }
      function formatDate(dateString) {
        // Parse the date string into a Date object
        const date = new Date(dateString);
    
        // Define an array of month names
        const months = [
            "January", "February", "March", "April", "May", "June", 
            "July", "August", "September", "October", "November", "December"
        ];
    
        // Extract day, month, and year from the Date object
        const day = date.getUTCDate(); // Use getUTCDate for consistent UTC handling
        const month = months[date.getUTCMonth()]; // getUTCMonth returns zero-based index
        const year = date.getUTCFullYear();
    
        // Format the string
        return `${day} ${month.slice(0,3)} ${year}`;
    }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
        setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'driver.truck.name' },
            { data: 'driver.first_name',render:function(data,type,row){
                return`<span>${data ? data: 'N/a'}</span>`;
            } },
            { data: 'service_date',render:function(data,type,row){
                return`<span>${data ? data: 'N/a'}</span>`;
            } },
            { data: 'status',render:function(data,type,row){
                return`<span>${data === 'not_resolved' ? `Not Resolved <i title="${row.description}" class="ph ph-info"></i>`: `Resolved <i title="${row.description}" class="ph ph-info"></i>`}</span>`;
            } },
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <button class="btn btn-success view-btn" data-id="${row.id}"><i class="ph ph-eye"></i></button>
                <button class="btn btn-danger delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i></button>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/edit-schedule-maintenance/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/view-issue-reported/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Issue Reports</h5>
            <div class="col-md-6 text-end">
           
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    
                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Vehicle Info</th>
                <th scope="col">Driver</th>
             
                <th scope="col">Service Date</th>
                
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default IssuesReportTable